import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { unsubscribe } from '../../Services/Website/WebsiteApi'; // Ensure this function calls your API endpoint

const UnsubscribePage = () => {
    const { token } = useParams();
    const navigate = useNavigate();
    const [status, setStatus] = useState('Processing your request…');
    const [isError, setIsError] = useState(false);

    useEffect(() => {
        if (!token) {
            setStatus('Invalid link. Please request a new one.');
            setIsError(true);
            return;
        }

        const processUnsubscribe = async () => {
            try {
                const response = await unsubscribe(token); // Should be GET /unsubscribe/:token
                if (response.message) {
                    setStatus(response.message);
                } else if (response?.error) {
                    setStatus(response?.error);
                    setIsError(true);
                } else {
                    setStatus('Something went wrong. Please try again.');
                    setIsError(true);
                }
            } catch (err) {
                setStatus(err);
                setStatus('Network error. Please try again.');
                setIsError(true);
            }

            // Redirect to homepage after 2s
            setTimeout(() => navigate('/'), 2000);
        };

        processUnsubscribe();
    }, [token, navigate]);

    return (
        <div
            className="d-flex flex-column justify-content-center align-items-center text-center"
            style={{ minHeight: '100vh' }}
        >
            <h3 className={isError ? 'text-danger' : 'text-success'}>{status}</h3>
        </div>
    );
};

export default UnsubscribePage;
